<div *routerOuter style="min-height: 50px">
  <div class="row">
    <div class="col col-120 col-lg-100 col-xl-80">
      <ng-template cdkPortal #actions="cdkPortal">
        <button class="btn btn-secondary" (click)="createSnapshot()">Create snapshot</button>
      </ng-template>
<!--      <ngx-json-viewer [json]="json" [expanded]="false"></ngx-json-viewer>-->

      <table class="table" *ngIf="snapshots.length">
        <thead>
        <tr>
          <th>#</th>
          <th>Date</th>
          <th>JSON</th>
        </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of snapshots; let index = index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.createdAt | moment }}</td>
            <td>
              <ngx-json-viewer [json]="item.json" [expanded]="false"></ngx-json-viewer>
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="!snapshots.length">Snapshot is not created</div>
    </div>
  </div>
  <preloader [hidden]="!loaderService.isLoading"></preloader>
</div>
